import NoDataWrapper from './NoDataWrapper';

export default NoDataWrapper;
